import styled from 'styled-components';

export const ConfirmEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
